// Countdown JS module for daisyUI

export function initCountdown() {
    const countdowns = document.querySelectorAll("[data-countdown]");
    countdowns.forEach((el) => {
        const target = el.getAttribute("data-countdown");
        if (!target) return;
        const targetDate = new Date(target);
        if (isNaN(targetDate.getTime())) return;

        // Query all inner spans once
        const daysSpan = el.querySelector(".countdown-days");
        const daysWrapper = el.querySelector(".countdown-days-wrapper");
        const hoursSpan = el.querySelector(".countdown-hours");
        const minutesSpan = el.querySelector(".countdown-minutes");
        const secondsSpan = el.querySelector(".countdown-seconds");

        function update() {
            const now = new Date();
            let diff = Math.floor((targetDate.getTime() - now.getTime()) / 1000);
            if (diff <= 0) {
                el.style.display = "none";
                return;
            }
            const days = Math.floor(diff / 86400);
            diff -= days * 86400;
            const hours = Math.floor(diff / 3600);
            diff -= hours * 3600;
            const minutes = Math.floor(diff / 60);
            const seconds = diff % 60;

            if (daysSpan) {
                // Show/hide the days wrapper in compact mode — keep hours < 24
                if (days > 0) {
                    daysSpan.textContent = days;
                    daysSpan.setAttribute("style", `--value:${days};`);
                    daysSpan.setAttribute("aria-label", days);
                    if (daysWrapper) daysWrapper.classList.remove("hidden");
                } else {
                    // hide whole wrapper (so the 'd' label is hidden too)
                    if (daysWrapper) daysWrapper.classList.add("hidden");
                }
            }
            if (hoursSpan) {
                hoursSpan.textContent = hours;
                hoursSpan.setAttribute("style", `--value:${hours};`);
                hoursSpan.setAttribute("aria-label", hours);
            }
            if (minutesSpan) {
                minutesSpan.textContent = minutes;
                minutesSpan.setAttribute("style", `--value:${minutes}; --digits: 2;`);
                minutesSpan.setAttribute("aria-label", minutes);
            }
            if (secondsSpan) {
                secondsSpan.textContent = seconds;
                secondsSpan.setAttribute("style", `--value:${seconds}; --digits: 2;`);
                secondsSpan.setAttribute("aria-label", seconds);
            }
        }
        update();
        const interval = setInterval(() => {
            if (el.style.display === "none") {
                clearInterval(interval);
                return;
            }
            update();
        }, 1000);
    });
}
